module.exports = __webpack_public_path__ + "static/img/1066.f909225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1066.jpg
// module id = 248
// module chunks = 0